// components/ArborDrawer/ProfileSection.js
import { useState } from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Image from "next/image";
import DefaultAvatar from "@/assets/default-avatar.svg";
import SettingsIcon from "@/assets/settings.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useAuth } from "@/contexts/AuthContext";
import { useQueryClient } from "@tanstack/react-query";
import useStore from "@/stores/store";

const ProfileSection = () => {
  const { signout, user } = useAuth();
  const queryClient = useQueryClient();
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState(null);
  const profileMenuOpen = Boolean(profileMenuAnchorEl);
  
  const handleProfileMenuClick = (event) => {
    setProfileMenuAnchorEl(event.currentTarget);
  };
  
  const handleProfileMenuClose = () => {
    setProfileMenuAnchorEl(null);
  };
  
  const handleSignOut = () => {
    queryClient.clear();
    useStore.getState().reset();
    signout();
    handleProfileMenuClose();
  };
  
  return (
    <ListItemButton
      sx={{
        minHeight: 48,
        px: 2,
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: 3,
          justifyContent: "center",
          color: "white",
        }}
      >
        <IconButton>
          <Image
            src={DefaultAvatar}
            alt="user-avatar"
            width={24}
            height={24}
          />
        </IconButton>
      </ListItemIcon>

      <ListItemText
        primaryTypographyProps={{
          fontWeight: "medium",
          variant: "body1",
          ml: -1.5,
        }}
        primary={user?.displayName ?? "John Doe"}
        sx={{ color: "white", mr: 3 }}
      />
      
      <ListItemIcon
        sx={{
          minWidth: 0,
          color: "white",
        }}
      >
        <IconButton sx={{ mr: -1.5 }} onClick={handleProfileMenuClick}>
          <Image
            src={SettingsIcon}
            alt="settings"
            width={20}
            height={20}
          />
        </IconButton>
        <Menu
          open={profileMenuOpen}
          onClose={handleProfileMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          anchorEl={profileMenuAnchorEl}
        >
          <MenuItem onClick={handleSignOut}>
            Sign Out
          </MenuItem>
        </Menu>
      </ListItemIcon>
    </ListItemButton>
  );
};

export default ProfileSection;